<div class="progress-bar-container">
    <p-progressBar class="progress-bar" mode="indeterminate" />
    <p class="progress-status">{{progressStatus || 'Thinking'}}</p>
</div>